import { defineComponent } from "vue";
import MessageAlert from "@/components/message-alert";
import { FormKit } from "@formkit/vue";
import * as Sentry from "@sentry/vue";

const FALLBACK_ERR_MESSAGE =
  "Nastala neočekávaná chyba. Prosím, kontaktujte naši Zákaznickou linku na čísle 730 430 430.";
const FORM_NAME = "contact me form: on-exit";

export default defineComponent({
  template: `
      <div class="exit-intent-content">
      <div class="text-content">
        <h4 class="text-xl mb-3">Sleva na tarif PODA NEO 7,5 GB bude platit už jen několik dní</h4>
        <p class="text-lg fw-light mb-3">
        Stále váháte? Zanechte nám na sebe kontakt. Ozveme se a rádi vám se vším pomůžeme.
        </p>
        <MessageAlert
            type="info"
            v-if="this.isSubmitted && !this.isPassed && this.errorMessage === null"
        >
          <span>Vaše údaje se zpracovávají. Moment strpení, prosím.</span>
        </MessageAlert>
        <MessageAlert
            type="success"
            v-if="this.isPassed && this.errorMessage === null"
        >
          <span>Děkujeme.</span>
        </MessageAlert>
        <MessageAlert
            type="error"
            v-if="!this.isPassed && this.errorMessage !== null"
        >
        <span
        >Nastala neočekávaná chyba. Prosím, kontaktujte naši Zákaznickou linku
          na čísle 730 430 430.</span
        >
        </MessageAlert>
        <FormKit
            type="form"
            @submit="handlePhoneNoContactSubmit"
            :submit-label="'Ozvěte se mi'"
            v-if="!this.isSubmitted && !this.isPassed && this.errorMessage === null"
        >
          <FormKit
              type="text"
              name="phone_no_contact"
              id="phone_no_contact"
              label="Telefonní číslo"
              v-model="this.phoneNoContact"
              validation="required"
              @focusout="handleFocusOut"
              :sections-schema="{
            prefix: {
              children: [
                {
                  $el: 'span',
                  attrs: {
                    style: 'margin-left: 0.5rem;',
                  },
                  // eslint-disable-next-line no-irregular-whitespace
                  children: '+420',
                },
              ],
            },
          }"
          />
        </FormKit>
      </div>
      <div class="exit-intent-image"></div>
      </div>
    `,
  name: "ExitIntentContent",
  components: {
    MessageAlert,
    FormKit,
  },
  data() {
    return {
      isSubmitted: false,
      isPassed: false,
      errorMessage: null,
      phoneNoContact: null,
    };
  },
  computed: {
    phoneNoContactTrimmed() {
      return "+420" + this.phoneNoContact?.replace(/\s/g, "");
    },
  },
  async mounted() {
    this.trackOpen();

    await this.$store.direct.getters.recaptchaService.init();
  },
  methods: {
    getCookie(name: string): string | null {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    async trackOpen() {
      await this.$store.direct.getters.exponeaService.track("order_form", {
        form_name: FORM_NAME,
        form_state: "opened",
        url: window.location.href,
        selected_tariff_technology: "sim",
      });
    },
    async handleFocusOut() {
      await this.$store.direct.getters.exponeaService.track("order_form", {
        form_name: FORM_NAME,
        form_state: "edited",
        field_key: "phone_no_contact",
        field_value: this.phoneNoContactTrimmed,
        url: window.location.href,
        selected_tariff_technology: "sim",
      });
    },
    async handlePhoneNoContactSubmit() {
      try {
        const podaAuthTrack = this.$store.direct.getters.cookieService.getCookieOne("poda_auth_track");
        this.errorMessage = null;
        this.isSubmitted = true;
        const webApiResponse = await this.$store.direct.getters.webApiService.createWebOrder({
          tel_num: this.phoneNoContactTrimmed,
          order_source: "web",
          tariff_technology: "sim",
          customer_type: "b2c",
          lead_info: this.$store.direct.getters.leadInfoService.getLeadInfo(),
          session_storage_id: this.$store.direct.getters.sessionStorageTagger.getTag(),
          persistent_storage_id: this.$store.direct.getters.localStorageTagger.getTag(),
          captcha: await this.$store.direct.getters.recaptchaService.getToken("order"),
          is_employee: podaAuthTrack !== "" && podaAuthTrack !== null,
        });
        await this.$store.direct.getters.exponeaService.track("order_form", {
          form_name: FORM_NAME,
          form_state: "submitted",
          form_step: 1,
          url: window.location.href,
          selected_tariff_technology: "sim",
        });
        await this.$store.direct.getters.gtmService.track("sim_exit_intent_submit", {
          web_order_uuid: webApiResponse?.uuid ?? null,
        });
        this.isPassed = true;
      } catch (error) {
        this.errorMessage = FALLBACK_ERR_MESSAGE;
        await this.$store.direct.getters.exponeaService.track("order_form", {
          form_name: FORM_NAME,
          form_state: "submit_failed",
          error_message: FALLBACK_ERR_MESSAGE,
          form_step: 1,
          url: window.location.href,
          selected_tariff_technology: "sim",
        });
        this.isPassed = false;
        Sentry.captureException(error);
      }
    },
  },
});
